// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_td-5";
export var filledCircle = "_td-4";
export var historyEntry = "_td-3";
export var messageSideLeft = "_td-1";
export var messageSideRight = "_td-2";
export var orderTrackingCarouselWrapper = "_td-6";
export var orderTrackingInfoContainer = "_td-0";